'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var locale = require('../enums/locale.js');

const DEFAULT_ISO_LANGUAGE_REGION = locale.IsoLanguagesRegions.EN;

exports.DEFAULT_ISO_LANGUAGE_REGION = DEFAULT_ISO_LANGUAGE_REGION;
//# sourceMappingURL=locale.js.map
